export default "__VITE_ASSET__CkpnPQKZ__"